import api from '@/apis/di/fundStructureAPI';
import Crud from '@/stores/crudBaseCache';
var crud = new Crud('fundStructure', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_fund_structure',
    field: {
      key: 'fund_structure_id',
      code: 'fund_structure_code',
      name: 'fund_structure_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
